module.exports = __webpack_public_path__ + "img/sto_bg_pos@2x.1b4d10a0.png";